import { _post } from "../Api";
import { toast } from "react-toastify";
import { setTaMerchant } from "./CloudActions";

export function updateTaMerchant(taMerchant, newData, oldValues) {
  return updateTaMerchants([taMerchant], [newData], [oldValues]).then((taMerchants) => {
    setTaMerchant(taMerchants[0]);
    return Promise.resolve(taMerchants[0]);
  });
}

export function updateTaMerchants(taMerchants, newData, oldValues, updatedKey = true) {
  let data = [];
  for (let i in taMerchants) {
    if (taMerchants[i]) {
      data.push({
        taMerchantId: taMerchants[i].id,
        ...newData[i],
      });
    } else {
      data.push({
        ...newData[i],
      });
    }
  }
  return _post("/nova/v2/ta_merchants/update", data)
    .then((res) => {
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    });
}
